export const iconFontAwesomeSpinnersHurricane = (
	<i className="fa-solid fa-hurricane"></i>
);
